import { FormikProps, getIn } from 'formik'
import React, { useId } from 'react'
import { ErrorLabel, Input, Label } from '..'
import { FontSize, MaskType } from '../../../_metronic/helpers'
import { useT } from '_metronic/i18n/Metronici18n'

interface FormInputProps {
  label?: string
  name: string
  placeholder?: string
  type?: 'text' | 'number' | 'password'
  mask?: MaskType
  formik: FormikProps<any>
  isDisabled?: boolean
  isRequired?: boolean
  className?: string
  infoText?: string
  labelSize?: FontSize
  highlight?: boolean
  entity?: string
  autoComplete?: 'off' | 'on' | 'new-password' | 'current-password'
}

export const FormInput: React.FC<FormInputProps> = ({
  label,
  name,
  placeholder,
  type = 'text',
  mask,
  formik,
  isDisabled = false,
  isRequired = false,
  className = '',
  infoText = '',
  labelSize,
  highlight,
  entity,
  autoComplete,
}) => {
  const { t } = useT()

  const errorMessage = getIn(formik.errors, name, null)
  const touched = getIn(formik.touched, name, '')

  const resolvedLabel = label ?? (entity ? t(`${entity}.label`) : undefined)

  // Id estável e único para associação programática label<->campo (AC5).
  // `useId` evita colisão quando o mesmo `name` aparece mais de uma vez na página;
  // o prefixo `name` mantém o id legível no DOM.
  const reactId = useId()
  const inputId = `${name}-${reactId}`

  return (
    <div className={`row ${className}`}>
      {resolvedLabel && (
        <Label
          className='mb-2'
          htmlFor={inputId}
          isRequired={isRequired}
          size={labelSize}
          infoText={infoText}
          highlight={highlight}
        >
          {resolvedLabel}
        </Label>
      )}
      <Input
        {...formik.getFieldProps(name)}
        id={inputId}
        placeholder={placeholder}
        type={type}
        mask={mask}
        entity={entity}
        autoComplete={autoComplete}
        isInvalid={formik.touched[name] && Boolean(formik.errors[name])}
        isValid={formik.touched[name] && !formik.errors[name]}
        disabled={formik.isSubmitting || isDisabled}
      />
      {touched && errorMessage && <ErrorLabel>{errorMessage}</ErrorLabel>}
    </div>
  )
}
